<template>
  <div class="dh-page">
    <!-- Banner -->
    <section class="dh-hero">
      <div class="dh-hero-grid" :style="{ backgroundImage: `url(${heroBg})` }">
        <div>
          <div class="dh-eyebrow">
            <span class="dh-eyebrow-dot"></span>法律行业大模型 ·
            专业法律智能应用
          </div>
          <h1 class="dh-hero-title">
            <span class="dh-hero-title-main">新知智法.AI法律助手</span>
            <span class="dh-hero-title-sub"
              >让法律工作
              <span class="dh-grad">更精准、更高效、更可信</span></span
            >
          </h1>
          <div class="dh-hero-tags">
            <span class="dh-tag">智能检索</span>
            <span class="dh-tag">智能生成</span>
            <span class="dh-tag">智能审查</span>
            <span class="dh-tag">专业法律知识库</span>
          </div>
          <div class="dh-hero-actions">
            <a
              class="dh-btn dh-btn-primary"
              @click="goFeature('/home/SearchHome')"
              >立即免费试用</a
            >
          </div>
        </div>
        <div class="dh-hero-visual"></div>
      </div>
      <div class="dh-trust-strip">
        <div class="dh-trust-item">
          <span class="dh-trust-icon">
            <svg viewBox="0 0 24 24">
              <path d="M4 6h16v12H4z"></path>
              <path d="M8 10h8M8 14h6"></path>
            </svg>
          </span>
          <span><b>法律专业知识能力</b><br />法规、案例与专业语义深度融合</span>
        </div>
        <div class="dh-trust-item">
          <span class="dh-trust-icon">
            <svg viewBox="0 0 24 24">
              <path d="M5 12h14M12 5v14"></path>
              <circle cx="12" cy="12" r="9"></circle>
            </svg>
          </span>
          <span><b>覆盖高频业务场景</b><br />查、写、审三大原子能力一体化</span>
        </div>
        <div class="dh-trust-item">
          <span class="dh-trust-icon">
            <svg viewBox="0 0 24 24">
              <path d="m12 3 7 3v5c0 5-3 8-7 10-4-2-7-5-7-10V6z"></path>
              <path d="M9 12h6"></path>
            </svg>
          </span>
          <span><b>支持本地化部署</b><br />保障法律业务数据隐私与系统稳定</span>
        </div>
      </div>
    </section>

    <!-- 产品能力概览 -->
    <section class="dh-overview">
      <div class="dh-container">
        <div class="dh-section-head">
          <h2>为法律工作提供专业可信的 AI 能力</h2>
          <p>
            依托法律行业大模型、专业法律知识库与智能体能力，把通用 AI
            转化为可真正进入法律工作流程的生产力工具。
          </p>
        </div>
        <div class="dh-overview-layout">
          <div class="dh-overview-copy">
            <div class="dh-overview-item">
              <div class="dh-overview-num">1.</div>
              <div>
                <h3>法律行业大模型，更懂法律业务</h3>
                <p>
                  面向法律专业场景进行深度训练与适配，能够理解法律术语、案件要素、文书结构及法律推理逻辑，在复杂问题中更准确地识别用户意图与业务上下文，为检索、分析和内容生成提供更专业的模型能力。
                </p>
              </div>
            </div>
            <div class="dh-overview-item">
              <div class="dh-overview-num">2.</div>
              <div>
                <h3>全量法律知识，结果更有依据</h3>
                <p>
                  内置法律、行政法规、地方性法规、司法解释、法条释义及标注案例等专业数据，并结合关联法条、类案与裁判观点，为法律检索、文书生成和内容审查持续提供可参考、可追溯的专业知识支撑。
                </p>
              </div>
            </div>
            <div class="dh-overview-item">
              <div class="dh-overview-num">3.</div>
              <div>
                <h3>检索、生成、审查，一体化应用</h3>
                <p>
                  以智能检索、智能生成、智能审查三大原子能力为核心，可灵活组合适配案件研判、法律研究、文书起草、合同与文件审查等高频任务；同时支持本地化与一体机部署，兼顾业务效率、数据隐私与系统稳定。
                </p>
              </div>
            </div>
            <!-- <div>
              <a
                class="dh-btn dh-btn-primary"
                @click="goFeature('/home/SearchHome')"
                >立即体验</a
              >
            </div> -->
          </div>
          <div class="dh-overview-demo" aria-label="产品能力概览示意">
            <img
              class="dh-overview-visual-img"
              :src="overviewImg"
              alt="AI法律助手能力概览"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 核心功能 -->
    <div class="dh-features">
      <section class="dh-feature-section">
        <div class="dh-container dh-feature-row">
          <div class="dh-feature-copy">
            <h2>智能检索</h2>
            <div class="dh-feature-index">
              全量法律数据 · 语义检索 · 类案研判
            </div>
            <p class="dh-lead">
              精准高效，快速找到法律依据与类案参考。支持语义、关键词与案例检索，辅助用户快速完成法律研究和案件研判。
            </p>
            <div class="dh-feature-list">
              <div class="dh-feature-item">
                <span class="dh-check">✓</span
                ><span
                  >覆盖国家法律、行政法规、地方性法规、司法解释等法律数据</span
                >
              </div>
              <div class="dh-feature-item">
                <span class="dh-check">✓</span
                ><span>支持语义检索、关键词检索、案例检索等多种检索方式</span>
              </div>
              <div class="dh-feature-item">
                <span class="dh-check">✓</span
                ><span>提供类案推送、法条关联与裁判观点提炼，辅助专业判断</span>
              </div>
            </div>
            <a
              class="dh-btn dh-btn-primary"
              @click="goFeature('/home/SearchHome')"
              >体验智能检索</a
            >
          </div>
          <div class="dh-feature-demo">
            <img
              class="dh-feature-art-img"
              :src="featureSearchImg"
              alt="智能检索功能示意"
            />
          </div>
        </div>
      </section>

      <section class="dh-feature-section alt">
        <div class="dh-container dh-feature-row">
          <div class="dh-feature-copy">
            <h2>智能生成</h2>
            <div class="dh-feature-index">
              多类型法律文书 · 一键起草 · 智能校验
            </div>
            <p class="dh-lead">
              从案件材料到专业法律文书，高效完成起草。根据案件要素与用户需求自动生成结构化文书，并支持持续补充和编辑完善。
            </p>
            <div class="dh-feature-list">
              <div class="dh-feature-item">
                <span class="dh-check">✓</span
                ><span
                  >支持诉状、答辩状、上诉状、律师函、合同等多类型法律文书</span
                >
              </div>
              <div class="dh-feature-item">
                <span class="dh-check">✓</span
                ><span>支持材料上传、要素式录入与多轮沟通等生成方式</span>
              </div>
              <div class="dh-feature-item">
                <span class="dh-check">✓</span
                ><span>支持文书预览、内容编辑、格式校验与结果下载</span>
              </div>
            </div>
            <a
              class="dh-btn dh-btn-primary"
              @click="goFeature('/home/DocumentHome')"
              >体验起诉状生成</a
            >
          </div>
          <div class="dh-feature-demo">
            <img
              class="dh-feature-art-img"
              :src="featureGenerateImg"
              alt="智能生成功能示意"
            />
          </div>
        </div>
      </section>

      <section class="dh-feature-section">
        <div class="dh-container dh-feature-row">
          <div class="dh-feature-copy">
            <h2>智能审查</h2>
            <div class="dh-feature-index">风险识别 · 修改建议 · 辅助决策</div>
            <p class="dh-lead">
              自动识别合同及法律文件中的风险点，提供风险说明、修改建议与修订内容，辅助法律人员快速完成初审与复核。
            </p>
            <div class="dh-feature-list">
              <div class="dh-feature-item">
                <span class="dh-check">✓</span
                ><span>定位潜在风险条款与关键问题，形成结构化审查结论</span>
              </div>
              <div class="dh-feature-item">
                <span class="dh-check">✓</span
                ><span>提供风险概述、修改建议、修订版本与清洁版本等结果</span>
              </div>
              <div class="dh-feature-item">
                <span class="dh-check">✓</span
                ><span
                  >可扩展利冲审查、IPO资料审查及案件风险研判等专业场景</span
                >
              </div>
            </div>
            <a
              class="dh-btn dh-btn-primary"
              @click="goFeature('/home/contract-review')"
              >体验智能审查</a
            >
          </div>
          <div class="dh-feature-demo">
            <img
              class="dh-feature-art-img"
              :src="featureReviewImg"
              alt="智能审查功能示意"
            />
          </div>
        </div>
      </section>
    </div>

    <!-- 业务场景 -->
    <section class="dh-scenario">
      <div class="dh-container">
        <div class="dh-section-head">
          <h2>覆盖多类法律业务场景</h2>
          <p>
            从司法办案到律师服务，再到企业法务，围绕不同角色的真实任务提供可组合的
            AI 能力。
          </p>
        </div>
        <div class="dh-scenario-grid">
          <article class="dh-scenario-card">
            <div class="dh-scenario-icon">
              <img :src="courtImg" alt="法院" />
            </div>
            <h3>法院</h3>
            <p>
              围绕审判办案流程，支持类案推送、法条检索、裁判观点提炼、法律文书生成与量刑辅助，帮助法官快速获取办案依据，提升案件研判与文书处理效率。
            </p>
          </article>
          <article class="dh-scenario-card">
            <div class="dh-scenario-icon">
              <img :src="administrationImg" alt="司法行政与仲裁" />
            </div>
            <h3>司法行政与仲裁</h3>
            <p>
              覆盖司法局复议、人社仲裁等业务，支持法条检索、复议决定书与仲裁文书生成、案件审查、类案推送及争议焦点分析，辅助规范办案流程并提升案件处理效率。
            </p>
          </article>
          <article class="dh-scenario-card">
            <div class="dh-scenario-icon">
              <img :src="lawImg" alt="律师事务所" />
            </div>
            <h3>律师事务所</h3>
            <p>
              面向律师日常办案与法律服务，支持利冲审查、诉状及律师函生成、类案检索、合同与文书审查，减少重复性基础工作，提升案件研究与客户响应效率。
            </p>
          </article>
          <article class="dh-scenario-card">
            <div class="dh-scenario-icon">
              <img :src="legalAffairsImg" alt="企业法务" />
            </div>
            <h3>企业法务</h3>
            <p>
              覆盖企业日常法律与合规需求，支持合同审查、法规查询、法律咨询、文书模板、诉讼指引与风险提示，帮助业务快速获得法律支持，降低合规与履约风险。
            </p>
          </article>
        </div>
      </div>
    </section>

    <!-- 落地成果 -->
    <section class="dh-results">
      <div class="dh-container">
        <div class="dh-section-head">
          <h2>从试点探索到真实业务落地</h2>
          <p>
            新致司法智能一体机（法律助手）已在多地司法行政与法律服务场景中投入使用，持续沉淀真实业务实践。
          </p>
        </div>
        <div class="dh-result-board">
          <div class="dh-result-board-copy">
            <h3>真实场景验证，持续提升法律工作效率</h3>
            <p class="dh-result-desc">
              目前产品已在重庆、上海、安徽、黑龙江、江苏、福建、广东等多地法院、司法局及律所投入使用，并形成规模化实践。
            </p>
            <div class="dh-metric-row">
              <div class="dh-metric"><b>7+</b><span>覆盖地区</span></div>
              <div class="dh-metric">
                <b>近10万份</b><span>辅助生成法律文书初稿</span>
              </div>
            </div>
            <p class="dh-result-note">
              *
              以上为已有产品资料中的阶段性数据，正式上线前建议再次核对公开口径。
            </p>
          </div>
          <div class="dh-map-box">
            <img
              class="dh-deployment-art-img"
              :src="deploymentMapImg"
              alt="产品落地地区覆盖"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 底部 CTA -->
    <section class="dh-cta-wrap">
      <div class="dh-container">
        <div class="dh-cta" :style="{ backgroundImage: `url(${ctaBg})` }">
          <h2>开启你的 AI 法律工作方式</h2>
          <p>
            智能检索、文书生成、智能审查，一站式提升法律工作效率，让专业法律能力更快进入真实业务流程。
          </p>
          <div class="dh-cta-actions">
            <a class="dh-btn secondary" @click="goFeature('/home/SearchHome')"
              >立即体验</a
            >
          </div>
        </div>
      </div>
    </section>

    <div class="dh-site-record">
      <div>
        Copyright©版权所有上海新致软件股份有限公司 渝ICP备2024033839号-2
      </div>

      <!-- Copyright © 马小莉 ICP备案号：渝ICP备2024033839号-2 网站：zhifa.law -->
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { message } from "ant-design-vue";
import heroBg from "@/assets/defaultHome/hero-bg.png";
import overviewImg from "@/assets/defaultHome/overview.png";
import featureSearchImg from "@/assets/defaultHome/feature-search.png";
import featureGenerateImg from "@/assets/defaultHome/feature-generate.png";
import featureReviewImg from "@/assets/defaultHome/feature-review.png";
import deploymentMapImg from "@/assets/defaultHome/deployment-map.png";
import courtImg from "@/assets/defaultHome/court.png";
import administrationImg from "@/assets/defaultHome/administration.png";
import lawImg from "@/assets/defaultHome/law.png";
import legalAffairsImg from "@/assets/defaultHome/legalAffairs.png";
import ctaBg from "@/assets/defaultHome/bg2.png";

const router = useRouter();

// 跳转功能页：未登录时引导登录并带跳转目标
const goFeature = (path) => {
  if (!localStorage.getItem("token")) {
    message.warning("请先登录");
    router.push({ path: "/NumberLogin", query: { redirect: path } });
    return;
  }
  router.push(path);
};
</script>

<style lang="less" scoped>
.dh-page {
  --dh-primary: #356cff;
  --dh-primary2: #7559ff;
  --dh-surface: #f6f8fc;
  --dh-shadow: 0 12px 34px rgba(30, 48, 88, 0.08);

  width: 100%;
  padding: 20px 0px 0px 8px;
  overflow: hidden;
  color: #171a21;
  line-height: 1.7;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC",
    "Microsoft YaHei", Arial, sans-serif;

  * {
    box-sizing: border-box;
  }

  h1,
  h2,
  h3,
  p {
    overflow-wrap: break-word;
  }
}

.dh-container {
  width: 100%;
  padding-left: 58px;
  padding-right: 58px;
}

/* 底部 CTA 通栏：容器不加左右 padding */
.dh-cta-wrap .dh-container {
  padding-left: 0;
  padding-right: 0;
}

/* ---------- 按钮 ---------- */
.dh-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  height: 44px;
  padding: 0 22px;
  border-radius: 6px;
  border: 1px solid transparent;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.18s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 18px rgba(53, 108, 255, 0.12);
  }
}

.dh-btn-primary {
  background: linear-gradient(100deg, var(--dh-primary), var(--dh-primary2));
  color: #fff;
}

/* ---------- Banner ---------- */
.dh-hero {
  padding: 0;
  background: transparent;
}

.dh-hero-grid {
  position: relative;
  display: grid;
  grid-template-columns: 1.08fr 0.92fr;
  align-items: center;
  /* 高度由背景图（2672x1000）比例控制，随宽度等比缩放 */
  aspect-ratio: 2672 / 1000;
  /* 文字尺寸/间距用 cqw 随容器宽度等比缩放，保证任何分辨率下内容都落在图内 */
  container-type: inline-size;
  padding: 4.6% 4.6% 4.2%;
  //   border-radius: 10px 10px 0 0;
  background-color: #f3f6fc;
  /* 图片自带约 20px 透明上圆角，放大 3% 让圆角落到容器外被裁掉（等比，无变形） */
  background-size: 103% 103%;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
}

.dh-hero-visual {
  display: none;
}

.dh-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 0.6cqw;
  border: 1px solid #d9e7ff;
  background: rgba(255, 255, 255, 0.68);
  color: #2467ef;
  padding: 0.6cqw 1.25cqw;
  border-radius: 999px;
  font-size: clamp(12px, 1.25cqw, 15px);
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(53, 108, 255, 0.04);
}

.dh-eyebrow-dot {
  width: 0.55cqw;
  height: 0.55cqw;
  min-width: 5px;
  min-height: 5px;
  border-radius: 50%;
  background: #1877f2;
}

.dh-hero-title {
  font-size: clamp(24px, 3.75cqw, 46px);
  line-height: 1.25;
  margin: 1.6cqw 0 1.9cqw;
  letter-spacing: -0.8px;
  font-weight: 600;
  color: #171a21;
}

.dh-hero-title-main {
  display: block;
  margin-bottom: 0.5cqw;
}

.dh-hero-title-sub {
  display: block;
  white-space: nowrap;
}

.dh-grad {
  background: linear-gradient(90deg, var(--dh-primary), var(--dh-primary2));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.dh-hero-tags {
  display: grid;
  grid-template-columns: repeat(2, max-content);
  column-gap: 3.6cqw;
  row-gap: 1.2cqw;
  margin: 0 0 2.7cqw;
}

.dh-tag {
  background: transparent;
  border: 0;
  padding: 0;
  font-size: clamp(12px, 1.45cqw, 17px);
  color: #667184;
  display: flex;
  align-items: center;
  gap: 0.9cqw;
  white-space: nowrap;

  &::before {
    content: "✓";
    width: 1.8cqw;
    height: 1.8cqw;
    border-radius: 50%;
    background: #1673ef;
    color: #fff;
    display: grid;
    place-items: center;
    font-size: clamp(9px, 1.05cqw, 13px);
    font-weight: 800;
    line-height: 1;
    flex: none;
  }
}

.dh-hero-actions .dh-btn-primary {
  min-width: 16.5cqw;
  height: clamp(38px, 4.2cqw, 50px);
  padding: 0 2cqw;
  font-size: clamp(13px, 1.45cqw, 16px);
}

/* Banner 下三项能力 */
.dh-trust-strip {
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 34px;
  padding: 22px 58px 24px;
  background: #fff;
  border: 1px solid #e8edf5;
  border-top: 0;
  //   border-radius: 0 0 10px 10px;
  z-index: 2;
}

.dh-trust-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 14px;
  color: #606a79;
  font-size: 14px;
  line-height: 1.65;
  text-align: left;

  b {
    display: inline-block;
    margin-bottom: 2px;
    font-size: 17px;
    line-height: 1.45;
    font-weight: 700;
    color: #242a35;
  }
}

.dh-trust-icon {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  border-radius: 8px;
  background: linear-gradient(145deg, #edf3ff, #f4f0ff);
  display: grid;
  place-items: center;
  color: var(--dh-primary);

  svg {
    width: 18px;
    height: 18px;
    stroke: currentColor;
    fill: none;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
}

/* ---------- 通用版块 ---------- */
.dh-section-head {
  text-align: center;
  max-width: 760px;
  margin: 0 auto 48px;

  h2 {
    font-size: 30px;
    line-height: 1.35;
    margin: 0 0 12px;
    letter-spacing: -0.2px;
    font-weight: 600;
    color: #171a21;
  }

  p {
    color: #7d8796;
    margin: 0;
    font-size: 15px;
    line-height: 1.8;
  }
}

/* ---------- 产品能力概览 ---------- */
.dh-overview {
  margin-top: 14px;
  background: #fff;
  border-radius: 10px;
  padding: 72px 0;
}

.dh-overview-layout {
  display: grid;
  grid-template-columns: minmax(410px, 0.88fr) minmax(520px, 1.12fr);
  gap: 64px;
  align-items: center;

  > * {
    min-width: 0;
  }
}

.dh-overview-copy {
  display: grid;
  gap: 27px;
  max-width: 520px;
  justify-self: start;
  text-align: left;
}

.dh-overview-item {
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 9px;
  row-gap: 10px;

  h3 {
    font-size: 21px;
    line-height: 1.5;
    margin: 0;
    font-weight: 700;
    color: #171a21;
    text-align: left;
  }

  p {
    grid-column: 1 / -1;
    font-size: 14px;
    line-height: 1.9;
    color: #7b8492;
    margin: 0;
    text-align: left;
  }
}

.dh-overview-num {
  font-size: 20px;
  line-height: 1.5;
  font-weight: 700;
  color: #171a21;
}

.dh-overview-demo {
  display: block;
  padding: 0;
}

.dh-overview-visual-img {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 18px;
  box-shadow: var(--dh-shadow);
}

/* ---------- 核心功能 ---------- */
.dh-feature-section {
  margin-top: 14px;
  border-radius: 10px;
  overflow: hidden;
  // background: var(--dh-surface);
  background-color: #f6f8fc;
  padding: 66px 0;

  &.alt {
    background: #fff;
  }
}

.dh-feature-row {
  display: grid;
  grid-template-columns: minmax(390px, 0.82fr) minmax(540px, 1.18fr);
  gap: 66px;
  align-items: center;
  min-height: 430px;

  > * {
    min-width: 0;
  }

  &.reverse {
    grid-template-columns: minmax(540px, 1.18fr) minmax(390px, 0.82fr);

    .dh-feature-copy {
      order: 2;
    }

    .dh-feature-demo {
      order: 1;
    }
  }
}

.dh-feature-copy {
  max-width: 520px;
  justify-self: start;
  text-align: left;

  h2 {
    font-size: 29px;
    line-height: 1.3;
    margin: 0 0 14px;
    font-weight: 600;
    color: #171a21;
  }
}

.dh-feature-index {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  border: 1px solid rgba(79, 104, 255, 0.28);
  background: linear-gradient(
    90deg,
    rgba(53, 108, 255, 0.045),
    rgba(117, 89, 255, 0.045)
  );
  color: #5268db;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 17px;
  line-height: 1.3;
}

.dh-lead {
  font-size: 15px;
  line-height: 1.9;
  color: #697383;
  margin: 0 0 20px;
}

.dh-feature-list {
  display: grid;
  gap: 11px;
  margin: 0 0 25px;
}

.dh-feature-item {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  font-size: 14px;
  line-height: 1.75;
  color: #68717f;
}

.dh-check {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  color: var(--dh-primary);
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  margin-top: 3px;
  font-size: 10px;
  font-weight: 700;
}

.dh-feature-demo {
  padding: 0;
}

.dh-feature-art-img {
  display: block;
  width: 100%;
  max-width: 676px;
  height: auto;
  margin: 0 auto;
  object-fit: contain;
}

/* ---------- 业务场景 ---------- */
.dh-scenario {
  margin-top: 14px;
  padding: 70px 0 74px;
  border-radius: 10px;
  overflow: hidden;
  // background: linear-gradient(180deg, #fafbfd 0%, #f5f8fd 100%);
  background: linear-gradient(180deg, #ffffff 0%, #f5f8fd 100%);
  border-radius: 10px 10px 10px 10px;
}

.dh-scenario-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  width: 100%;

  > * {
    min-width: 0;
  }
}

.dh-scenario-card {
  position: relative;
  overflow: hidden;
  min-height: 330px;
  padding: 40px 24px 30px;
  border-radius: 24px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.62) 0%,
    rgba(255, 255, 255, 0.76) 100%
  );
  border: 1px solid rgba(255, 255, 255, 0.88);
  box-shadow: 0 20px 44px rgba(38, 52, 85, 0.075),
    inset 0 1px 0 rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  transition: 0.22s ease;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background: radial-gradient(
        circle at 20% 8%,
        rgba(255, 255, 255, 0.98),
        transparent 29%
      ),
      linear-gradient(180deg, rgba(255, 255, 255, 0.3), transparent 42%);
    pointer-events: none;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 24px 52px rgba(31, 54, 98, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.92);
  }

  h3 {
    position: relative;
    z-index: 1;
    font-size: 21px;
    line-height: 1.35;
    text-align: center;
    margin: 0 0 18px;
    font-weight: 700;
    color: #171a21;
  }

  p {
    position: relative;
    z-index: 1;
    font-size: 15px;
    line-height: 1.85;
    color: #667181;
    margin: 0;
    text-align: left;
  }
}

.dh-scenario-icon {
  position: relative;
  width: 68px;
  height: 68px;
  margin: 2px auto 20px;
  display: grid;
  place-items: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
}

/* ---------- 落地成果 ---------- */
.dh-results {
  margin-top: 14px;
  padding: 72px 0;
  border-radius: 10px;
  background: #fff;
}

.dh-result-board {
  display: grid;
  grid-template-columns: minmax(390px, 0.86fr) minmax(540px, 1.14fr);
  gap: 64px;
  align-items: center;

  > * {
    min-width: 0;
  }
}

.dh-result-board-copy {
  max-width: 520px;
  justify-self: start;
  text-align: left;

  h3 {
    font-size: 26px;
    line-height: 1.35;
    margin: 0 0 10px;
    font-weight: 700;
    color: #171a21;
  }
}

.dh-result-desc {
  font-size: 14px;
  color: #748197;
  margin: 0;
}

.dh-metric-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 22px;
}

.dh-metric {
  border-radius: 8px;
  background: var(--dh-surface);
  border: 1px solid #e8ecf3;
  padding: 22px;
  text-align: left;

  b {
    display: block;
    font-size: 36px;
    background: linear-gradient(100deg, var(--dh-primary), var(--dh-primary2));
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    line-height: 1.1;
  }

  span {
    font-size: 13px;
    color: #7f8997;
  }
}

.dh-result-note {
  font-size: 11px;
  color: #a0a9b8;
  margin-top: 14px;
}

.dh-deployment-art-img {
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 10px;
}

/* ---------- 底部 CTA ---------- */
.dh-cta-wrap {
  margin-top: 14px;
  padding: 0;
}

.dh-cta {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 10px;
  /* 高度由背景图（2672x512）比例控制，随宽度等比缩放；文字用 cqw 等比缩放，保证内容落在图内 */
  aspect-ratio: 2672 / 512;
  container-type: inline-size;
  padding: 2cqw 36px;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  color: #fff;
  text-align: center;

  h2 {
    font-size: clamp(20px, 2cqw, 31px);
    margin: 0 0 0.6cqw;
    font-weight: 500;
  }

  p {
    margin: 0 auto 1.3cqw;
    max-width: 46cqw;
    font-size: clamp(12px, 1cqw, 15px);
    color: rgba(255, 255, 255, 0.82);
  }

  .dh-btn {
    background: #fff;
    color: #4d61ed;
    box-shadow: none;

    &.secondary {
      width: 160px;
      background: transparent;
      color: #fff;
      border-color: rgba(255, 255, 255, 0.45);
    }
  }
}

.dh-cta-actions {
  display: flex;
  gap: 0.8cqw;
  justify-content: center;
  flex-wrap: wrap;
}

/* ---------- 备案信息 ---------- */
.dh-site-record {
  margin: 14px 0 0;
  padding: 8px 24px 0px;
  color: #8a94a5;
  font-size: 12px;
  line-height: 1.6;
  text-align: center;
}

/* ---------- 响应式（对齐设计稿工作台适配层） ---------- */
@media (max-width: 1500px) {
  .dh-page {
    padding: 20px 0px 0px 8px;
  }

  .dh-container {
    padding-left: 44px;
    padding-right: 44px;
  }

  .dh-trust-strip {
    padding-left: 44px;
    padding-right: 44px;
  }

  .dh-overview-layout,
  .dh-feature-row,
  .dh-result-board {
    gap: 44px;
  }

  .dh-feature-art-img {
    max-width: 620px;
  }
}

@media (max-width: 1250px) {
  .dh-trust-strip {
    padding: 20px 36px;
  }

  .dh-container {
    padding-left: 36px;
    padding-right: 36px;
  }

  .dh-overview-layout,
  .dh-feature-row,
  .dh-feature-row.reverse,
  .dh-result-board {
    grid-template-columns: 1fr 1fr;
    gap: 34px;
  }

  .dh-scenario-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .dh-feature-art-img {
    max-width: 560px;
  }

  .dh-site-record {
    font-size: 11px;
  }
}
</style>
